import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import { Form } from 'reactstrap'
import BillGeneratModal from '../../../../components/Modal/BillGeneratModal';
import SelectTable from '../../../../components/SelectTable';
import axios from 'axios';
import { loaderAction } from '../../../../redux/actions/Index';
import { environment } from '../../../../env';
import { useDispatch, useSelector } from 'react-redux';
import PriceFormater from '../../../../Helper/PriceFormater';
import moment from 'moment';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import PathName from '../../../../components/PathName/PathName';
import Table from '../../../../components/Table';
import { useNavigate } from 'react-router-dom';
import { Printer } from "@phosphor-icons/react";
import { toast } from 'react-toastify';
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';
import LoadBox from '../../../../components/Loading/LoadBox';

const Generatedbills = (props) => {
    const [rentpay, setRentpay] = useState([])
    const [filterdata, setFilterdata] = useState(undefined)
    const [filterBuilding, setFilterBuilding] = useState([]);
    const [projectLists, setProjectLists] = useState([]);
    const [dateDisable, setDateDisable] = useState(moment().format('YYYY-MM'));
    const [billdata, setBilldata] = useState([])
    const [pageNo, setPageNo] = useState(1);
    const [records, setRecords] = useState(10);
    const [nextIsValid, setNextIsValid] = useState(false);
    const [prevIsValid, setPrevIsValid] = useState(false);
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const [filteredInvoice, setFilteredInvoice] = useState([]);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const SendFrom = useSelector((state) => state?.ModalReducer?.sendFrom);
    const navigate = useNavigate()
    const apiTimeOut = useRef(null);
    const [loading, setLoading] = useState(false);


    const dispatch = useDispatch();
    const {
        register,
        watch,
        reset,
        control,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();

    var selectedProject = watch('project');
    var selectedBuilding = watch('building');
    var billing_type = watch('billing_type');
    var selectedInvestor = watch('investor');
    var selectedTenant = watch('tenant');
    var selectedmonth = watch('month');
    var search = watch('search')

    search = search == undefined? "" : search


    const BuildingOptions = async (query) => {
        let filteredBuildings;
        const filteredBuildingURL = `${environment.baseUrl}filter-building/`;
        const FilterBuildingPayload = new FormData();
        FilterBuildingPayload.append('query', query);

        const result = await axios.post(filteredBuildingURL, FilterBuildingPayload).then((response) => {
            let filteredBuilding = [];
            let tempArrayFilterWithProject = [];
            response.data.map((BuildingList) => {
                if(userProject == BuildingList?.project){
                    filteredBuilding.push({ label: BuildingList.building_no, value: BuildingList.id })
                }
            })
            tempArrayFilterWithProject = filteredBuilding?.sort((a, b) =>
                                                a?.building_no?.localeCompare(b.building_no))
            filteredBuildings = tempArrayFilterWithProject;
        })

        if (filteredBuildings.length > 0) {
            return filteredBuildings
        } else {
            return []
        }
    };

    useMemo(() => {
        if(userProject){
            let filterBuildingDefaultList = [];
            buildingList?.map(item => {
                if(item?.project?.id == userProject){
                    filterBuildingDefaultList.push({ label: item.building_no, value: Number(item.id) })
                }
            })
            filterBuildingDefaultList = filterBuildingDefaultList?.sort((a, b) =>
                                                        a?.building_no?.localeCompare(b.building_no))
            setFilterBuilding(filterBuildingDefaultList)
        }
    }, [userProject, buildingList])

    useMemo(() => {
        let cc = [];

        if (projectList) {
            projectList.map((project) => {
                cc.push({ label: project.name, value: project.id })
            })
        }
        setProjectLists(cc)
    }, [projectList]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const filterGenBillApi = (localPageNo = undefined, localRecord = undefined) => {
        if(selectedmonth && userProject != undefined){
            const date = new Date(selectedmonth);
            const year = date.getFullYear();
            const month = date.getMonth();
            const startDate = new Date(year, month, 1);
            const endDate = new Date(year, month + 1, 0);
            let url = "";
            if(localPageNo == undefined && localRecord == undefined){
                if(pageNo != 1){
                    setPageNo(1)
                }
                url = `${environment.baseUrl}gen-billing-filter/?investor_name=${search == undefined ? "" : search}&bill_type=${billing_type == undefined ? "rent" : billing_type}&rent_date_after=${formatDate(startDate)}&rent_date_before=${formatDate(endDate)}&project=${userProject}&building_number=${selectedBuilding == undefined ? "" : selectedBuilding.value}&p=1&records=${records}`;
            }else if(localPageNo != undefined){
                url = `${environment.baseUrl}gen-billing-filter/?investor_name=${search == undefined ? "" : search}&bill_type=${billing_type == undefined ? "rent" : billing_type}&rent_date_after=${formatDate(startDate)}&rent_date_before=${formatDate(endDate)}&project=${userProject}&building_number=${selectedBuilding == undefined ? "" : selectedBuilding.value}&p=${localPageNo}&records=${records}`
            }else if(localRecord != undefined){
                url = `${environment.baseUrl}gen-billing-filter/?investor_name=${search == undefined ? "" : search}&bill_type=${billing_type == undefined ? "rent" : billing_type}&rent_date_after=${formatDate(startDate)}&rent_date_before=${formatDate(endDate)}&project=${userProject}&building_number=${selectedBuilding == undefined ? "" : selectedBuilding.value}&p=1&records=${localRecord}`
            }
            axios.get(url).then((res)=>{
                if(res?.data?.next != null && nextIsValid != true){
                    setNextIsValid(true)
                }else if(res?.data?.next == null && nextIsValid != false){
                    setNextIsValid(false)
                }
                if(res?.data?.previous != null && prevIsValid != true){
                    setPrevIsValid(true)
                }else if(res?.data?.previous == null && prevIsValid != false){
                    setPrevIsValid(false)
                }

                if(res?.data?.results.length > 0){
                    setFilteredInvoice(res.data.results)
                }else{
                    setFilteredInvoice([])
                }
            }).catch((err) => {
                console.log(err);
                setFilteredInvoice([])
                toast.error('Something went wrong', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
            })
        }
    }

    useMemo(() => {
        if((selectedBuilding || billing_type) && userProject != undefined){
            filterGenBillApi()
        }
    },[billing_type, selectedmonth, selectedBuilding])

    useMemo(() => {
        if(userProject != undefined){
            if(loading != true){
                setLoading(true)
            }
            if(apiTimeOut.current){
                clearTimeout(apiTimeOut.current)
            }
            apiTimeOut.current = setTimeout(()=> {
                filterGenBillApi()
                apiTimeOut.current = null;
                setLoading(false)
            },[1500])
        }
    },[search])

    const pageChangeHandler = (LocalPageNo) => {
        if(((pageNo < LocalPageNo) && nextIsValid) || ((pageNo > LocalPageNo) && prevIsValid)){
          filterGenBillApi(LocalPageNo, undefined) // page change call
          setPageNo(LocalPageNo)
        }
      }
    
      const recordChangeHandler = (recordSize) => {
        filterGenBillApi(undefined, recordSize) // record change call
        setRecords(recordSize);
        setPageNo(1);
      }

    const columns = [
        {
            name: 'Bill Type',
            selector: row => row?.bill_type == "rent" ? "Rent" : (row?.bill_type == "maintenance" ? "Maintenance" : (row?.bill_type == "varai" ? "Varai" : (row?.bill_type == "extra_amenities" ? "Extra Amenities" : (row?.bill_type == "other_charges" ? "Other charges" : row?.bill_type)))),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Bill Date',
            selector: row => moment(row?.rent_date).format('MMM-YYYY'),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Investor',
            selector: row => row?.gala_investor?.investor?.Investors.name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Tenant',
            selector: row => row?.tenant?.proposal?.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Building',
            selector: row => row?.gala_investor?.investor?.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Gala',
            selector: row => row.gala_investor?.investor?.gala?.gala_no + " " + "Gala",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Rent/Sq.Ft',
            selector: row => <PriceFormater price={row?.rate} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Amount',
            selector: row => <PriceFormater price={row?.amount} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'GST',
            selector: row => <PriceFormater price={parseInt((row?.amount) * (0.09))} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Bill Amount',
            selector: row => <PriceFormater price={Number(row?.amount) + Number(parseInt((row?.amount) * (0.09)))} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Action',
            selector: row => <button
                onClick={() => navigatePrint(row)}
                className="bg-background-color border-0 p-3 rounded"
            >
                <Printer size="30" className="text-base-color" />
            </button>,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
    ];

    const navigatePrint = (data) => {
        let rentpay = []
        rentpay.push(data)
        navigate('/BillInvoice', { state: { payData: rentpay } })
    }

    useEffect(() => {
        if(userProject != undefined){
            filterGenBillApi()
            reset({ 'month': moment().format('YYYY-MM') })
        }
    }, [userProject])
    const monthDis = (e) => {
        if ((moment(e.target.value).format('YYYY-MM')) > moment().format('YYYY-MM')) {
            setDateDisable((moment().format('YYYY-MM')))
        } else {
            setDateDisable(moment().format('YYYY-MM'));
        }
    }

    return (
        <>
            <PathName />
            <div className="Building-main">
                <Form >
                    <div className='my-4 row'>
                        <div className={'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'}>
                            <input className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                type='search'
                                autoComplete='off'
                                placeholder='Search Party Name...'
                                {...register('search')}
                            /> 
                            <br />
                        </div>
                        <div className={'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'}>
                            <div className='w-100'>
                                <select
                                    id="billing_type"
                                    name="billing_type"
                                    defaultValue="rent"
                                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 py-4 modal-input"
                                    {...register("billing_type")}
                                >
                                    {/* <option value="">Select Billing Type</option> */}
                                    <option value="rent">Rent</option>
                                    <option value="maintenance">Maintenance</option>
                                    <option value="varai">Varai</option>
                                    <option value="extra_amenities">Extra Amenities </option>
                                    <option value="other_charges">Other charges </option>
                                    {/* <option value="electricitybill">Electricity bill</option> */}
                                </select>
                            </div>
                            <br />
                        </div>
                        {/* {
                            billing_type !== 'rent' && billing_type !== '' && <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                                <div className='w-100'>
                                    <select
                                        id="send_from"
                                        name="send_from"
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 py-4 modal-input"
                                        {...register("send_from")}
                                    >
                                        <option value="">Select Send From</option>
                                        <option value="sumeet_developer">Sumeet Developer</option>
                                        <option value="Sumeet_maintenance">Sumeet Maintenance</option>
                                    </select>
                                </div>
                                <br />
                            </div>
                        } */}

                        <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                            <div className='w-100'>
                                <Controller
                                    control={control}
                                    name="building"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange },
                                        fieldState: { isTouched, isDirty, error },
                                        formState,
                                    }) => (
                                        <AsyncSelect placeholder="Search Building" cacheOptions defaultOptions={filterBuilding} loadOptions={BuildingOptions} className='w-100' onChange={onChange} />
                                    )}
                                />
                            </div>
                            <br />
                        </div>
                        <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                            <div className='w-100'>
                                <input
                                    className='p-3 shadow-none   w-100  title-font-500 fs-2  border-radius-10 modal-input '
                                    type='month'
                                    max={dateDisable}
                                    autoComplete='off'
                                    placeholder='Search Investor Here...'
                                    {...register("month", { onChange: (e) => { monthDis(e) } })}
                                />
                            </div>
                            <br />
                        </div>
                        {/* <div className='col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 '>
                            <button type="button" onClick={Clear} className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
                        </div> */}
                    </div>
                </Form>
                {loading && <div className="bg-white p-5 rounded-5 mb-5"><LoadBox /></div>}
                {!loading && <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                    {
                        filteredInvoice ? filteredInvoice.length == 0 ? <EmptyTable /> : (<><Table columns={columns} data={filteredInvoice} pageinationProp={true}/> 
                        <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
                            <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                                {""}
                            </div>
                            <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
                                <select
                                    className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                                    defaultValue={"10"}
                                    {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
                                >
                                    <option value="8">8</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                
                                </select>
                                <span onClick={() => {pageChangeHandler(pageNo-1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold"/></span>
                                <span onClick={() => {pageChangeHandler(pageNo+1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold"/></span>
                            </div>
                        </div>
                        </>)
                            :
                            <>
                                {filteredInvoice.length != 0 ? <Table columns={columns} data={filteredInvoice} /> : <EmptyTable />}
                            </>
                    }
                </div>}
            </div>
        </>
    )
}

export default Generatedbills